import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgModule } from '@angular/core';
import { AgGridModule } from '@ag-grid-community/angular';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { DashboardModule } from './components/dashboard/dashboard.module';
import { SharedModule } from './shared/shared.module';
import { ProductsModule } from './components/products/products.module';
import { SalesModule } from './components/sales/sales.module';
import { CouponsModule } from './components/coupons/coupons.module';
import { PagesModule } from './components/pages/pages.module';
import { MediaModule } from './components/media/media.module';
import { MenusModule } from './components/menus/menus.module';
import { VendorsModule } from './components/vendors/vendors.module';
import { UsersModule } from './components/users/users.module';
import { LocalizationModule } from './components/localization/localization.module';
import { InvoiceModule } from './components/invoice/invoice.module';
import { SettingModule } from './components/setting/setting.module';
import { ReportsModule } from './components/reports/reports.module';
import { AuthModule } from './components/auth/auth.module';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';

import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatButtonModule } from '@angular/material/button';
import { MatSliderModule } from '@angular/material/slider';
import { MatIconModule } from '@angular/material/icon';
import { ReactiveFormsModule } from '@angular/forms';
import { FormsModule } from '@angular/forms';
import { ProfileComponent } from './components/setting/profile/profile.component';//
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { MatDialogModule } from '@angular/material/dialog';
import { ProductsService } from 'src/app/shared/service/product.service';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { HttpProfilerInterceptor } from './shared/service/http-profiler.interceptor';
import { MatTabsModule } from '@angular/material/tabs';
import { LoadingComponent } from './components/loading/loading.component';
import { MatChipsModule } from '@angular/material/chips';
import { LandingCursoComponent } from './components/landing-curso/landing-curso.component';
import { CommonModule } from '@angular/common';
import { AddQuizComponent } from './components/quizs/add-quiz/add-quiz.component';
import { EmailEditorModule } from 'angular-email-editor';
import { MatDatepickerModule } from '@angular/material/datepicker';
import {GuidedTourModule, GuidedTourService} from 'ngx-guided-tour';
import { StudentsModule } from './components/students/students.module';
import { VideotecaInvitationComponent } from './components/videoteca/videoteca-invitation/videoteca-invitation.component';

@NgModule({
  declarations: [
    AppComponent, 
    ProfileComponent, 
    AddQuizComponent,
    VideotecaInvitationComponent
  ],
  imports: [

    BrowserAnimationsModule,
    BrowserModule.withServerTransition({ appId: 'serverApp' }),
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatCheckboxModule,
    MatButtonModule,
    MatSliderModule,
    MatIconModule,
    AppRoutingModule,
    DashboardModule,
    InvoiceModule,
    SettingModule,
    MatTabsModule,
    ReportsModule,
    AuthModule,
    SharedModule,
    LocalizationModule,
    ProductsModule,
    SalesModule,
    VendorsModule,
    CouponsModule,
    PagesModule,
    MediaModule,
    MenusModule,
    UsersModule,
    AgGridModule,
    FormsModule,
    NgbModule,
    MatDialogModule,
    HttpClientModule,
    MatChipsModule,
    CommonModule,
    EmailEditorModule,
    MatDatepickerModule,
    GuidedTourModule,
    StudentsModule,
    // CountToModule,
    // CountoModule,
  ],
  providers: [
    provideAnimationsAsync(),
    ProductsService,
    GuidedTourService,
  { provide: HTTP_INTERCEPTORS, useClass: HttpProfilerInterceptor, multi: true },
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
